import React from "react";
import { useLocation } from "react-router-dom";
import { PhoneIcon } from "lucide-react";
import { ButtonLink } from "../shared/Button";

// [Conversion] Persistent mobile actions. Hidden on /contact (the form is the page). Post-conversion enhancement in Bricks.
export function MobileActionBar() {
  const location = useLocation();
  if (location.pathname.startsWith("/contact")) return null;
  return <div className="fixed inset-x-0 bottom-0 z-30 border-t border-line bg-paper px-4 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 md:hidden" data-id="element-94" data-mp="122xqy6a2ca8o">
      <div className="grid grid-cols-[auto_1fr] gap-2" data-id="element-95" data-mp="y36upn1rp1wr">
        <a href="tel:+61862850876" className="inline-flex min-h-[52px] items-center justify-center gap-2 rounded-full border-[1.5px] border-charcoal px-4 text-[15px] font-semibold text-charcoal" data-id="element-96" data-mp="t32c9rhatx3w">
          <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-97" data-mp="2nfiiisa3hb8r" /> Call
        </a>
        <ButtonLink to="/contact" data-id="element-98" data-mp="2ihz3hq5koufr">Book a consultation</ButtonLink>
      </div>
    </div>;
}